import { MeasureProgress } from './measure-progress.model';
import { MeasureTask } from './measure-task.model';
import { GeoDsMeta } from './meta-data.model';
import { Person } from './person.model';
import { Resource } from './resource.model';
import { SubProject } from './sub-project.model';

export class Measure extends GeoDsMeta {
  ParentId: string;
  AreaManager: Person;
  CompletionDate: Date;
  Concept: string;
  CurrentGrade: string;
  CurrentState: string;
  Designation: string;
  DefenseMeasures: string;
  Dependencies: string;
  EndDate: Date;
  ExpectedResults: string;
  Goal: string;
  InitialSituation: string;
  MeasureDocuments: Document[];
  MeasureResources: Resource[];
  MeasureTasks: MeasureTask[];
  OriginalTargetDate: Date;
  PrevDect: PrevDect;
  OrgaTech: OrgaTech;
  Responsible: Person;
  ReleaseDate: Date;
  ResponsibleConsultant: Person;
  Status: string;
  StartDate: Date;
  Title: string;
  MeasureProgress?: MeasureProgress[];
  SubProject?: SubProject;
  IdRefPersonResponsible:string;
  IdRefPersonAreaManager:string;
  IdRefPersonSponsor: string
  constructor(data) {
    super();
    Object.assign(this, data);
  }
}
export interface DelegationLetterStatus {
  name: string;
  value: string;
}
export const ObligationStatus = [
  { name: 'Offen', value: 'Offen' },
  { name: 'Delegiert', value: 'Delegiert' },
];

export const MeasureStatus = [
  { name: 'Erfüllt', value: 'Erfüllt' },
  { name: 'Fällig', value: 'Fällig' },
  { name: 'Überfällig', value: 'Überfällig' },
  { name: 'Offen', value: 'Offen' },
  { name: 'Ständig', value: 'Ständig' },
];

export const DelegationLetterStatus :DelegationLetterStatus[] = [
  { name: 'Offen', value: '1' },
  { name: 'Unterschrieben', value: '2' },
  { name: 'Erstellt', value: '0' },
  { name: 'Bestätigt', value: '3' },
  { name: 'Archived', value: '4' },
];

export const DelegationLetterKind = [
  { name: 'Vorlage', value: '0' },
  { name: 'Delegationsschreiben', value: '1' }
];
export enum PrevDect {
  PREVENTIVE = 'Preventive',
  DETECTIVE = 'Detective',
}

export enum OrgaTech {
  ORGANIZATIONAL = 'Organizational',
  TECHNICAL = 'Technical',
}
